import React from 'react';

/**
 * The course's overall progress beside "أداؤك وتقدّمك" — Figma node 16370:190347.
 *
 * The file exports the arc as a fixed 72% path, so it is drawn here as a
 * stroked circle instead, with the design's own geometry: a 108px box, a track
 * of r 49.85 and 8.31 wide in gray/200, and the green arc 8.64 wide on the
 * radius that puts its outer edge on the box.
 *
 * It starts at twelve o'clock and runs clockwise in both languages. A clock
 * face does not mirror, and the design's arc is not a reading-order element.
 */
const TRACK_RADIUS = 49.8462;
const TRACK_WIDTH = 8.30769;
const ARC_RADIUS = 49.68;
const ARC_WIDTH = 8.64;
const CIRCUMFERENCE = 2 * Math.PI * ARC_RADIUS;

const RingGauge = ({ value, caption, label }) => {
    const percent = Math.min(100, Math.max(0, Math.round(Number(value) || 0)));

    return (
        <div role="img" aria-label={label} className="tw-relative tw-size-[108px] tw-shrink-0">
            <svg width="108" height="108" viewBox="0 0 108 108" aria-hidden className="tw-block tw--rotate-90">
                <circle
                    cx="54"
                    cy="54"
                    r={TRACK_RADIUS}
                    fill="none"
                    strokeWidth={TRACK_WIDTH}
                    className="tw-stroke-v2-neutral-200"
                />
                <circle
                    cx="54"
                    cy="54"
                    r={ARC_RADIUS}
                    fill="none"
                    strokeWidth={ARC_WIDTH}
                    strokeDasharray={CIRCUMFERENCE}
                    strokeDashoffset={CIRCUMFERENCE * (1 - percent / 100)}
                    className="tw-stroke-v2-student-progress tw-transition-[stroke-dashoffset] tw-duration-700"
                />
            </svg>

            <div aria-hidden className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-leading-[1.5]">
                <span className="tw-text-[20px] tw-font-bold tw-text-v2-student-value">{percent}%</span>
                <span className="tw-text-[11px] tw-text-v2-student-nav">{caption}</span>
            </div>
        </div>
    );
};

export default RingGauge;
